import * as type from 'store/actions/types';
import { paneContentModes, slateTypes } from 'config/constants';

// Hydrate inline content from sessionStorage for refresh recovery
var hydratedContentJson = null;
var hydratedContentMode = null;
var hydratedSlateUUID = null;
var hydratedSlateType = slateTypes.slate;
var hydratedIsPaneOpen = false;
var hydratedIsPaneHidden = false;
var hydratedNavList = [];
var hydratedIsPaneDocked = false;
var hydratedPaneUnpinned = false;
try {
  var savedMode = sessionStorage.getItem('slatePaneContentMode');
  if (savedMode === paneContentModes.TEMPLATE || savedMode === paneContentModes.DEMO) {
    var savedContent = sessionStorage.getItem('slatePaneContent');
    if (savedContent) {
      hydratedContentJson = JSON.parse(savedContent);
      hydratedContentMode = savedMode;
      hydratedIsPaneOpen = true;
    }
  } else if (savedMode === paneContentModes.SLATE) {
    var savedUUID = sessionStorage.getItem('slatePaneSlateUUID');
    if (savedUUID) {
      hydratedSlateUUID = savedUUID;
      var savedSlateType = sessionStorage.getItem('slatePaneSlateType');
      if (savedSlateType) {
        hydratedSlateType = savedSlateType;
      }
      hydratedIsPaneOpen = true;
    }
  }

  // Restore visual state from sessionStorage if available
  var savedPaneOpen = sessionStorage.getItem('slatePaneOpen');
  var savedPaneHidden = sessionStorage.getItem('slatePaneHidden');
  if (savedPaneOpen !== null) {
    hydratedIsPaneOpen = savedPaneOpen === 'true';
  }
  if (savedPaneHidden !== null) {
    hydratedIsPaneHidden = savedPaneHidden === 'true';
  }

  var savedPaneDocked = sessionStorage.getItem('slatePaneDocked');
  if (savedPaneDocked !== null) {
    hydratedIsPaneDocked = savedPaneDocked === 'true';
  }
  var savedPaneUnpinned = sessionStorage.getItem('slatePaneUnpinned');
  if (savedPaneUnpinned !== null) {
    hydratedPaneUnpinned = savedPaneUnpinned === 'true';
  }

  var savedNavList = sessionStorage.getItem('slatePaneNavList');
  if (savedNavList) {
    hydratedNavList = JSON.parse(savedNavList);
  }
} catch (e) { /* ignore */ }

var initialState = {
  isPaneOpen: hydratedIsPaneOpen,
  isPaneHidden: hydratedIsPaneHidden,
  isPaneDocked: hydratedIsPaneDocked,
  paneUnpinnedByUser: hydratedPaneUnpinned,
  slateInSlatePaneUUID: hydratedSlateUUID,
  contentJson: hydratedContentJson,
  slatePaneNavList: hydratedNavList,
  slatePaneSlateType: hydratedSlateType,
  slatePaneDockedTabs: [],
  slatePaneForceRefresh: null,
  contentMode: hydratedContentMode,
  contentModified: false,
  liveContentData: null,
};

var slatePane = function (state, action) {
  if (state === undefined) state = initialState;

  switch (action.type) {
    case type.UPDATE_SLATE_PANE_STATE: {
      let newState = Object.assign({}, state);
      if (action.payload.isPaneOpen !== undefined) {
        newState.isPaneOpen = action.payload.isPaneOpen;
      }
      if (action.payload.isPaneHidden !== undefined) {
        newState.isPaneHidden = action.payload.isPaneHidden;
      }
      if (action.payload.isPaneDocked !== undefined) {
        newState.isPaneDocked = action.payload.isPaneDocked;
      }
      if (action.payload.paneUnpinnedByUser !== undefined) {
        newState.paneUnpinnedByUser = action.payload.paneUnpinnedByUser;
      }
      if (action.payload.slateInSlatePaneUUID !== undefined) {
        newState.slateInSlatePaneUUID = action.payload.slateInSlatePaneUUID;
        if (action.payload.slateInSlatePaneUUID) {
          newState.contentJson = null;
        }
      }
      if (action.payload.contentJson !== undefined) {
        newState.contentJson = action.payload.contentJson;
        if (action.payload.contentJson) {
          newState.slateInSlatePaneUUID = null;
        }
      }
      if (action.payload.slatePaneNavList !== undefined) {
        newState.slatePaneNavList = action.payload.slatePaneNavList;
      }
      if (action.payload.slatePaneSlateType !== undefined) {
        newState.slatePaneSlateType = action.payload.slatePaneSlateType;
      }
      if (action.payload.slatePaneDockedTabs !== undefined) {
        newState.slatePaneDockedTabs = action.payload.slatePaneDockedTabs;
      }
      if (action.payload.slatePaneForceRefresh !== undefined) {
        newState.slatePaneForceRefresh = action.payload.slatePaneForceRefresh;
      }
      if (action.payload.contentModified !== undefined) {
        newState.contentModified = action.payload.contentModified;
      }
      if (action.payload.contentMode !== undefined) {
        newState.contentMode = action.payload.contentMode;
      }
      if (action.payload.liveContentData !== undefined) {
        newState.liveContentData = action.payload.liveContentData;
      }
      return newState;
    }

    case type.SLATE_PANE_CONTENT_LOADED: {
      return Object.assign({}, state, {
        contentMode: action.payload.mode,
        contentModified: false,
        liveContentData: null,
      });
    }

    case type.SLATE_PANE_CONTENT_CHANGED: {
      return Object.assign({}, state, {
        contentModified: true,
        liveContentData: action.payload.slateData !== undefined ? action.payload.slateData : state.liveContentData,
      });
    }

    case type.SLATE_PANE_CONTENT_SAVED: {
      return Object.assign({}, state, {
        contentModified: false,
      });
    }

    case type.CLEAR_SLATE_VIEWS: {
      return Object.assign({}, initialState, {
        contentJson: null,
        contentMode: null,
        contentModified: false,
        liveContentData: null,
        isPaneOpen: false,
        isPaneHidden: false,
        isPaneDocked: false,
        paneUnpinnedByUser: false,
        slateInSlatePaneUUID: null,
        slatePaneNavList: [],
      });
    }

    default:
      return state;
  }
};

export default slatePane;
